import React, { useContext } from 'react'
import {
  dateCol,
  dateTimeCol,
  numCol,
  strCol,
} from '@integec/grid-tools/lib/cols'
import { unitIdHeader } from 'core/HeaderColTypeProps'
import { getApiTargetInfo, getUnitNameMap, isValidYearRange } from 'core'
import { connect } from 'react-redux'
import { getMarginHourlyCA } from 'api/pgads.js'
import CommonScreen from 'admin/component/CommonScreen'
import { DatePickerContext, UnitSelectionContext } from 'context'
import { DatePicker, message } from 'antd'
const OaHourly = ({ unitNameMap }) => {
  const { setVisibleUnitSelection } = useContext(UnitSelectionContext)
  const { selectedDateRangePicker, setSelectedDateRagePicker } = useContext(
    DatePickerContext
  )

  const beforeRetrieveValidation = ({ validYearRange }, s, units) => {
    if (units.length <= 0) {
      message.error('Please, Select  Unit(s)')
      setVisibleUnitSelection(true)
      return false
    }
    const validYear = isValidYearRange(
      validYearRange,
      selectedDateRangePicker[0],
      selectedDateRangePicker[1]
    )
    if (!validYear) return false
    return true
  }

  const screenCriteria = (s, p, u, onChange) => {
    return (
      <DatePicker.RangePicker
        style={{ marginLeft: '15px' }}
        allowClear={false}
        format="MM/DD/YYYY"
        value={selectedDateRangePicker}
        onChange={d => {
          setSelectedDateRagePicker(d)
          onChange()
          // retrieve({ dates: d })
        }}
      />
    )
  }

  const withCriteria = (s, p, selectedUnits) => ({
    units: selectedUnits.map(u => u.unitId),
    start: selectedDateRangePicker[0].format('YYYY-MM-DD'),
    end: selectedDateRangePicker[1].format('YYYY-MM-DD'),
  })

  const OaHourlyHeaders = [
    // strCol({ ident: 'utility', display: 'Utility', isKey: true }),
    // strCol({ ident: 'unit', display: 'Unit', isKey: true }),
    {
      ...unitIdHeader,
      dataFormatter: ({ value }) => unitNameMap[value] || value,
      sortIndexGetter: ({ rowData }) =>
        unitNameMap[rowData.unitId] || rowData.unitId,
      sortOrder: 'asc',
    },
    dateCol({
      ident: 'transdate',
      display: 'Date',
      isKey: true,
      sortOrder: 'asc',
    }),
    numCol({ ident: 'hour', display: 'Hour', isKey: true, sortOrder: 'asc' }),
    strCol({
      ident: 'eventtype',
      display: 'Event Type',
      isFiltered: true,
      sortOrder: 'asc',
    }),
    strCol({ ident: 'availableMw', display: 'Available MW', isFiltered: true }),
    strCol({ ident: 'capacity', display: 'Capacity', isFiltered: true }),
    strCol({ ident: 'marketPrice', display: 'Market Price', isFiltered: true }),
    strCol({
      ident: 'variableCost',
      display: 'Variable Cost',
      isFiltered: true,
      width: 200,
    }),
    strCol({
      ident: 'numeretor',
      display: 'Numeretor',
      isFiltered: true,
      width: 200,
    }),
    strCol({
      ident: 'denominator',
      display: 'Denominator',
      isFiltered: true,
      width: 200,
    }),
    dateTimeCol({
      ident: 'modifiedDate',
      display: 'Modified Date',
      width: 200,
      showInRowEditor: false,
      dataFormat: 'YYYY-MM-DD[T]HH:mm:SS.sssZZ',
      displayFormat: 'MM/DD/YYYY HH:mm:SS',
      type: 'date-time',
      isKey: true,
    }),
  ]

  const sortOptions = OaHourlyHeaders

  return (
    <CommonScreen
      sortOptions={sortOptions}
      withCriteria={withCriteria}
      screenCriteria={screenCriteria}
      title="Hourly CA"
      header={OaHourlyHeaders}
      retrieveTask={getMarginHourlyCA}
      altBy={d => d.unitId}
      widthOffset={50}
      insertComp={false}
      insertCompHeight={0}
      onInsertEvent={_ => false}
      allowInsert={false}
      withoutModify
      withDelete={false}
      withUnitSelection
      beforeRetrieveValidation={beforeRetrieveValidation}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  unitNameMap: getUnitNameMap(state),
})

export default connect(mapStateToProps)(OaHourly)
